export enum ResponseStatusType {
    NotFound = 404,
}